// Shared formatting for the Account Expansion report.

// Whole-dollar currency, e.g. 12400 -> "$12,400".
export const formatCurrency = (value: number): string =>
  (value ?? 0).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });

// Signed currency for deltas, e.g. 800 -> "+$800", -300 -> "-$300".
export const formatSignedCurrency = (value: number): string => {
  const sign = value > 0 ? "+" : value < 0 ? "-" : "";
  return `${sign}${formatCurrency(Math.abs(value ?? 0))}`;
};

// e.g. 103.4 -> "103.4%".
export const formatPercent = (value: number): string =>
  `${(value ?? 0).toFixed(1)}%`;

// Definition of the calendar-year "rev lost" figures, shown as a tooltip on their
// columns. These are dollars, not a run-rate: the ARR toggle's x12 must never touch
// them (render them like Total Invoiced, without the factor).
export const REVENUE_LOST_NOTE =
  "Lost MRR × months left in the calendar year, counting this month. " +
  "Assumes the account stays lost through December. Not annualized.";

// CSV field quoting.
export const escCsv = (val: string): string =>
  /[",\n]/.test(val) ? `"${val.replace(/"/g, '""')}"` : val;
